export const MAX_WORK_SHIFT_DURATION_HOURS = 10

export const MATRICULE_PREFIX = 'AGD'
export const MATRICULE_INTERIM_PREFIX = 'AGDI'
export const MATRICULE_SUBCONTRACTING_PREFIX = 'AGDS'
export const MATRICULE_DIGITS = 6

export const WORK_SHIFT_STEP_DURATION_MINUTES = 5

export const MINIMUM_BREAK_BETWEEN_SHIFTS_MINUTES = 20

// Coupure entre 2 shifts (même collaborateur, même jour, boutiques différentes) strictement
// inférieure à ce seuil => temps de trajet payé et ventilé. Source : @gozoki/tools.
export { MAX_PAID_TRANSPORT_GAP_MINUTES } from '@gozoki/tools'
export const MAX_WEEKLY_HOURS = 35
export const MAX_CONSECUTIVE_WORK_DAYS = 6

export const CLOCK_COMMENT_REQUIRED_THRESHOLD_MINUTES = 5
export const WORK_SHIFT_MANAGER_COMMENT_MAX_LENGTH = 500

// Départ après minuit (kanban #924), seuils communs à l'écran de pointage (BO) et à l'API :
// - un shift ouvert de la VEILLE reste rattachable à un départ pendant 3 h après sa fin planifiée ;
// - un départ ne se pose pas sur un shift sans arrivée qui commence dans plus de 30 min
//   (tolérance pour les départs pointés un peu avant l'heure, cas réels en prod).
export const PREVIOUS_DAY_CLOCK_OUT_WINDOW_MINUTES = 180
export const CLOCK_OUT_FUTURE_START_TOLERANCE_MINUTES = 30

export const CLOCK_PHOTO_RETENTION_DAYS = 15

export const SHORT_LABEL_MAX_LENGTH = 30

/** Plus grande valeur d'une colonne `integer` Postgres : au-delà, l'écriture échouerait en 500. */
export const PG_INTEGER_MAX = 2_147_483_647

/**
 * Rampe d'un entrant de rotation, en jours de vente : sa part héritée de ses sortants s'efface
 * jusqu'à ce que sa part mesurée compte seule (spec rotations §5.3). Défaut `rotationRampDays` du
 * moteur de prévisions, et durée affichée par le back-office.
 */
export const ROTATION_RAMP_DAYS = 14

/**
 * Fenêtre de la part figée p̂ d'un sortant ou d'un analogue de rotation, en jours avant N (spec
 * rotations §5.2) : base de la prévision des entrants et de l'impact estimé affiché par le
 * back-office.
 */
export const ROTATION_SHARE_DAYS = 28

/**
 * Impact estimé d'une rotation (liste du back-office) : calculé seulement pour les rotations dont
 * N tombe dans ces derniers jours ou plus tard.
 */
export const ROTATION_IMPACT_HISTORY_DAYS = 30

export const PLANNING_VALIDATION_NOTICE =
  'Les plages horaires indiquées dans les plannings sont validées par les personnes concernées.'
